export default "skymp5-front/6c9b49df398dc6131ded21f2363c4d12.png";